import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm, useStore } from "react-admin";
import CreateSaveForm from "./CreateSaveForm";

const STORE_KEY = "sportSchedule.filters";

const CreateSportSchedule = () => {
  const [savedFilters] = useStore(STORE_KEY);
  const hasSavedFilters = savedFilters && Object.keys(savedFilters).length > 0;

  return (
    <Create
      title="Създаване на разписания за спорт"
      actions={<BackButtonToolbar />}
      transform={data => {
        const { academicYearId, structuralUnitId, instructionLanguageId, studyTypeId, ...payload } = data;
        return payload;
      }}
    >
      <SimpleForm defaultValues={savedFilters}>
        <CreateSaveForm hasSavedFilters={hasSavedFilters} />
      </SimpleForm>
    </Create>
  );
};

export default CreateSportSchedule;
